import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  CommonGrid,
  HeaderContainer,
  PageTitle,
} from '../../styledComponents/common';
import CardsList from './CardsList';
import SelfieFilter from './SelfieFilter';
import TopPagination from '../../components/Pagination/TopPagination/TopPagination';
import BottomPagination from '../../components/Pagination/BottomPagination/BottomPagination';

const Selfie = props => {
  const {
    selectedOrganization,
    organizationMembersList,
    getOrganizationMembersList,
    getSelfieList,
    isSelfieLoading,
    selfieList,
    pageSize,
    selfieCount,
    officesShortList,
    getOfficesShortList,
  } = props;

  const { t } = useTranslation();
  const [selectedMember, setSelectedMember] = useState('');
  
  const [selectedOffice, setSelectedOffice] = useState({
    label: t('all_offices'),
    value: null,
  });
  const [selectedDate, setSelectedDate] = useState({
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  });
  const [currentPagination, setCurrentPagination] = useState(1);

  useEffect(() => {
    const payload = {
      startDate: selectedDate.startDate,
      endDate: selectedDate.endDate,
      officeId: selectedOffice.value,
      userId: selectedMember.id,
      page: currentPagination,
    };

    console.log('payload', payload);
    getSelfieList(payload);
  }, [selectedMember, selectedDate, selectedOffice, currentPagination]);

  const selectMember = person => {
    setSelectedMember(person);
    setCurrentPagination(1);
  };

  const selectDate = date => {
    setSelectedDate({
      startDate: moment(date.startDate).format('YYYY-MM-DD'),
      endDate: moment(date.endDate).format('YYYY-MM-DD'),
    });
  };

  const selectOffice = office => {
    setSelectedMember('');
    setCurrentPagination(1);
    setSelectedOffice(office);
    if (!office.value) {
      getOrganizationMembersList({ office_id: null });
    } else {
      getOrganizationMembersList(office.id);
    }
  };

  const clearMember = () => {
    setSelectedMember('');
    setCurrentPagination(1);
  };

  const handlePageChange = page => {
    setCurrentPagination(page);
  };

  return (
    <div className="content">
      <CommonGrid alignItem="center">
        <PageTitle>{t('selfie_image')}</PageTitle>
      </CommonGrid>
      <HeaderContainer>
        <SelfieFilter
          membersList={organizationMembersList}
          getOrganizationMembersList={getOrganizationMembersList}
          officesShortList={officesShortList}
          getOfficesShortList={getOfficesShortList}
          selectMember={selectMember}
          handleDateChange={selectDate}
          selectedMember={selectedMember}
          clearMember={clearMember}
          selectedOffice={selectedOffice}
          selectOffice={selectOffice}
        />
      </HeaderContainer>
      {selfieCount && selfieCount > 0 && pageSize ? (
        <TopPagination
          itemName={t('Tasks')}
          totalCount={selfieCount}
          currentPage={currentPagination}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
      <CardsList
        isLoading={isSelfieLoading}
        selfieList={selfieList}
        count={selfieCount}
      />
      {selfieCount && selfieCount > 0 && pageSize ? (
        <BottomPagination
          totalCount={selfieCount}
          currentPage={currentPagination}
          onPageChange={page => handlePageChange(page)}
          pageSize={pageSize}
        />
      ) : null}
    </div>
  );
};

export default Selfie;
